import React, { useEffect, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { authenticationService } from '../jwt/_services';

const checkAndRefreshSession = async () => {
  // Auth.currentSession auto-refreshes using the refresh token if needed
  const session = await Auth.currentSession();

  const now = Math.floor(Date.now() / 1000);
  const idExp = session.getIdToken().getExpiration();
  const accessExp = session.getAccessToken().getExpiration();

  if (idExp > now && accessExp > now) return session;

  // Rare fallback: force a refresh explicitly
  const cognitoUser = await Auth.currentAuthenticatedUser({ bypassCache: true });
  await new Promise((resolve, reject) => {
    cognitoUser.refreshSession(session.getRefreshToken(), (err) => {
      if (err) return reject(err);
      resolve();
    });
  });

  return Auth.currentSession();
};

export const PrivateRoute = ({ component: Component, ...rest }) => {
  const [status, setStatus] = useState('checking'); // 'checking' | 'authed' | 'unauth'

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        // If your app keeps a cached user, quick check first:
        const cached = authenticationService.currentUserValue;
        if (!cached) {
          setStatus('unauth');
          return;
        }

        const session = await checkAndRefreshSession();

        // (Optional) Update your auth store with the fresh tokens
        // authenticationService.setSession({
        //   idToken: session.getIdToken().getJwtToken(),
        //   accessToken: session.getAccessToken().getJwtToken(),
        //   refreshToken: session.getRefreshToken().getToken(),
        //   payload: session.getIdToken().decodePayload(),
        // });

        console.log("PrivateRoute refreshed session: " + JSON.stringify(session.getIdToken()));

        localStorage.setItem('currentUser', JSON.stringify(session.getIdToken()));
        authenticationService.setCurrentUser(session.getIdToken());

        console.log("PrivateRoute refreshed session 2: " + JSON.stringify(session.getIdToken()));

        if (mounted) setStatus('authed');
      } catch (e) {

        console.log("PrivateRoute refreshed session error: " + JSON.stringify(e));
        try { authenticationService.logout(); } catch {}
        if (mounted) setStatus('unauth');
      }
    })();

    return () => { mounted = false; };
  }, []);

  return (
    <Route
      {...rest}
      render={props => {
        if (status === 'checking') {
          return <div style={{ opacity: 0.6, fontSize: 12, textAlign: 'center' }}>Checking session…</div>;
        }
        if (status === 'unauth') {
          return <Redirect to={{ pathname: '/authentication/login', state: { from: props.location } }} />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
